import { createFileRoute, Link, Navigate } from '@tanstack/react-router'
import { SignUp, useAuth } from '../lib/auth'

export const Route = createFileRoute('/signup')({
  component: SignupPage,
})

function SignupPage() {
  const { isLoaded, isSignedIn } = useAuth()

  if (isLoaded && isSignedIn) {
    return <Navigate to="/app" />
  }

  return (
    <div className="min-h-screen bg-snow flex flex-col">
      <header className="p-4">
        <Link to="/" className="text-2xl font-display font-semibold text-charcoal">
          MiseBook
        </Link>
      </header>

      <main className="flex-1 flex items-center justify-center p-4">
        <SignUp />
      </main>
    </div>
  )
}
